import { useRef } from "react";
import collaborateIcon from "../../../assets/general/carbon_collaborate.svg";
import certificateIcon from "../../../assets/general/carbon_certificate.svg";
import cropHealthIcon from "../../../assets/general/carbon_crop-health.svg";
import categoriesIcon from "../../../assets/general/carbon_categories.svg";
import { FeatureCard, type FeatureCardData } from "./FeatureCard";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

const FEATURE_CARDS: FeatureCardData[] = [
  {
    icon: collaborateIcon,
    title: "INTUITIVE PROJECT COLLABORATION",
    items: [
      "Coordinate processes across teams",
      "Simplified documentation and approvals",
      "Easily share project information",
    ],
  },
  {
    icon: certificateIcon,
    title: "ADVANCED CLIENT REPORTING",
    items: [
      "High-level Owner dashboard",
      "Track schedules and budgets",
      "Reporting available for all company types",
    ],
  },
  {
    icon: cropHealthIcon,
    title: "INCREASED TRANSPARENCY",
    items: [
      "Flexible version control in the document repository",
      "Customized sharing for required privacy",
      "Action item responsibility and verification",
    ],
  },
  {
    icon: categoriesIcon,
    title: "FIELD DOCUMENTATION",
    items: [
      "Mobile and tablet applications developed for on-site activities",
      "Increased documentation with less creation effort",
      "Enhanced photo management and filtering",
    ],
  },
];

export function FeatureCards() {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: ".square", stagger: 0.1 });

  return (
    <section
      ref={sectionRef}
      id="section-five"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding">
        <div className="fifth-section">
          <div className="square-section">
            {FEATURE_CARDS.map((card) => (
              <FeatureCard key={card.title} card={card} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
